import { FeatureToggleClientService } from 'feature-toggle-client';
export const PayerAccountAction = 'payer-account-tab';
export class PayerAccountActionFeatures {
    static async payerAccountActionApplicationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(PayerAccountAction);
    }
}
